<div class="betslip-workbench" role="dialog" aria-label="Betslip workbench">
	<header class="top">
		<span class="debug-badge">Debug</span>
		<div>
			<h1>Betslip workbench</h1>
			<p>
				Production <code>BetslipCreateService</code>, strategies, solvers and validators on an isolated betslip.
				Change a limit on the left, watch the Betslip on the right. Your real betslip is not touched.
			</p>
		</div>
		<button type="button" class="close" (click)="close()" title="Close (Esc)">&times;</button>
	</header>

	<main>
		<aside class="panel left"><dt-workbench-limits-panel /></aside>
		<section class="panel middle"><dt-workbench-offer-panel /></section>
		<aside class="panel right"><dt-workbench-betslip-panel /></aside>
	</main>
</div>
